import type { EntryPoint, EntryPointComponent, PreloadFetchPolicy } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type teamPreviewPanelQuery,
} from './__generated__/teamPreviewPanelQuery.graphql';
import type { TeamPreviewPanelProps } from './types';

type EntryPointParams = { cloudId: string };
const fetchPolicy: PreloadFetchPolicy = 'network-only';

type TeamPreviewPanelEntryPointComponent = EntryPointComponent<
	{
		queryReference: teamPreviewPanelQuery;
	},
	Record<string, never>,
	TeamPreviewPanelProps,
	Record<string, never>
>;

const teamPreviewPanelEntryPoint: EntryPoint<
	TeamPreviewPanelEntryPointComponent,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<TeamPreviewPanelEntryPointComponent>(
		/* webpackChunkName: "@atlaskit-internal_@atlassian/entry-point-fixtures/TeamPreviewPanel" */ './index',
		{ moduleId: 'team-preview-panel-entrypoint' },
	),
	getPreloadProps: ({ cloudId }: EntryPointParams) => ({
		queries: {
			queryReference: {
				parameters,
				variables: {
					cloudId,
				},
				options: {
					fetchPolicy,
				},
			},
		},
	}),
});

export default teamPreviewPanelEntryPoint;
